import { Component, input, InputSignal } from '@angular/core';
import { NgClass } from '@angular/common';
import { Alignment, IHeadline, HTag } from './headline.model';
import { SafeContent } from '../../../util-pipes/safe-content.pipe';

@Component({
  selector: 'app-headline',
  imports: [NgClass, SafeContent],
  templateUrl: './headline.html',
})
export class Headline {
  readonly content: InputSignal<IHeadline | null> = input<IHeadline | null>(
    null,
  );
  readonly showDivider: InputSignal<boolean | null> = input<boolean | null>(
    true,
  );
  readonly showDoubleDivider: InputSignal<boolean | null> = input<
    boolean | null
  >(false);

  readonly hTag = HTag;
  readonly alignment = Alignment;
}
